<template>
  <div
    class="bg-card rounded-[16px] p-6 border border-border relative overflow-hidden"
  >
    <div
      v-if="watermark"
      class="absolute inset-0 bg-background/80 backdrop-blur-[2px] flex items-center justify-center z-10 pointer-events-none"
    >
      <div
        class="text-[48px] font-bold text-foreground/10 transform -rotate-12 whitespace-nowrap"
      >
        COMING SOON
      </div>
    </div>

    <div
      class="flex items-center justify-between mb-6"
      :class="{ 'opacity-40': watermark }"
    >
      <h2 class="text-[14px] font-semibold text-foreground">Feed</h2>
      <router-link
        to="/feed"
        class="text-[12px] text-muted-foreground hover:text-foreground flex items-center gap-2"
      >
        Go To Post Feed
        <span
          class="w-6 h-6 rounded-full border border-border flex items-center justify-center"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.5 2.5L8 6L4.5 9.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
      </router-link>
    </div>

    <div
      class="rounded-[16px] border border-border p-6"
      :class="{ 'opacity-40': watermark }"
    >
      <div class="flex items-start justify-between gap-4">
        <div class="flex items-start gap-3">
          <img
            :src="userAvatar"
            alt="User"
            class="w-11 h-11 rounded-full object-cover"
          />
          <div class="min-w-0">
            <p class="text-[14px] font-semibold text-foreground truncate">
              {{ userName }}
            </p>
            <p class="text-[12px] text-muted-foreground mt-0.5">
              UI/UX Designer
            </p>
          </div>
        </div>

        <div class="flex items-center gap-2">
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] border border-[#F79009] text-[#F79009] bg-[#FFFAEB]"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 1.5C4.23858 1.5 2 3.73858 2 6.5C2 9.26142 4.23858 11.5 7 11.5C9.76142 11.5 12 9.26142 12 6.5C12 3.73858 9.76142 1.5 7 1.5Z"
                stroke="currentColor"
                stroke-width="1.2"
              />
              <path
                d="M7 4V6.7L8.7 8.4"
                stroke="currentColor"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Design
          </span>
          <button
            type="button"
            class="w-8 h-8 rounded-full flex items-center justify-center hover:bg-muted transition-colors"
            aria-label="More"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 3.5C8.55228 3.5 9 3.05228 9 2.5C9 1.94772 8.55228 1.5 8 1.5C7.44772 1.5 7 1.94772 7 2.5C7 3.05228 7.44772 3.5 8 3.5Z"
                class="fill-muted-foreground"
              />
              <path
                d="M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z"
                class="fill-muted-foreground"
              />
              <path
                d="M8 14.5C8.55228 14.5 9 14.0523 9 13.5C9 12.9477 8.55228 12.5 8 12.5C7.44772 12.5 7 12.9477 7 13.5C7 14.0523 7.44772 14.5 8 14.5Z"
                class="fill-muted-foreground"
              />
            </svg>
          </button>
        </div>
      </div>

      <p class="text-[13px] text-foreground leading-relaxed mt-6">
        The UI/UX Design course on the TCC learning portal has been helpful so
        far. Day 8 of my self-improvement journey ✨
        <span class="text-[#2E90FA]">#UI/UX</span>
        <span class="text-[#2E90FA]">#Community</span>
      </p>

      <div
        class="mt-5 h-[220px] rounded-[12px] border border-border feed-dots"
      ></div>

      <div
        class="flex items-center gap-6 text-[12px] text-muted-foreground pt-4 mt-5 border-t border-border"
      >
        <button class="flex items-center gap-1.5 hover:text-foreground">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00065 13.8663C7.54732 13.8663 7.09398 13.7063 6.74065 13.3863L2.58732 9.67967C1.16065 8.423 0.333984 6.623 0.333984 4.74301C0.333984 1.12301 3.26732 -1.33699 6.60065 0.349674C7.24065 0.683007 7.66065 1.15634 8.00065 1.73634C8.34065 1.15634 8.76732 0.683007 9.40065 0.349674C12.734 -1.33699 15.6673 1.11634 15.6673 4.74301C15.6673 6.623 14.834 8.423 13.414 9.67301L9.26065 13.3863C8.90732 13.7063 8.45398 13.8663 8.00065 13.8663Z"
              fill="currentColor"
            />
          </svg>
          100
        </button>
        <button class="flex items-center gap-1.5 hover:text-foreground">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.66602 14.6663H10.3327C13.3327 14.6663 14.666 13.333 14.666 10.333V9.66634C14.666 6.66634 13.3327 5.33301 10.3327 5.33301H5.66602C2.66602 5.33301 1.33268 6.66634 1.33268 9.66634V10.333C1.33268 13.333 2.66602 14.6663 5.66602 14.6663Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 5.33366V1.33366"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          26
        </button>
        <span class="ml-auto">15 September, 2026</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedCard",
  props: {
    userAvatar: { type: String, required: true },
    userName: { type: String, required: true },
    watermark: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.feed-dots {
  background-color: #ffffff;
  background-image: radial-gradient(
    rgba(16, 24, 40, 0.12) 1px,
    transparent 1px
  );
  background-size: 10px 10px;
}
</style>
